import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ChangePassword from "./pages/ChangePassword";
import Dashboard from "./pages/Dashboard";
import MyTasks from "./pages/MyTasks";
import CreateTask from "./pages/CreateTask";
import Kanban from "./pages/Kanban";
import Calendar from "./pages/Calendar";
import Admin from "./pages/Admin";
import MiSemana from "./pages/MiSemana";
import SeguimientoEjecutivo from "./pages/SeguimientoEjecutivo";
import ErrorBoundary from "./components/ErrorBoundary";

const SmartRedirect = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'Usuario') return <Navigate to="/mi-semana" replace />;
  return <Navigate to="/dashboard" replace />;
};

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <ErrorBoundary>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ErrorBoundary>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/tasks" 
            element={
              <ProtectedRoute>
                <Layout>
                  <MyTasks />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/tasks/create" 
            element={
              <ProtectedRoute>
                <Layout>
                  <CreateTask />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/kanban" 
            element={
              <ProtectedRoute>
                <Layout>
                  <Kanban />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/calendar" 
            element={
              <ProtectedRoute>
                <Layout>
                  <Calendar />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route
            path="/mi-semana"
            element={
              <ProtectedRoute>
                <Layout>
                  <MiSemana />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/seguimiento"
            element={
              <ProtectedRoute allowedRoles={['Presidencia', 'Gerencia']}>
                <Layout>
                  <SeguimientoEjecutivo />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={['Presidencia']}>
                <Layout>
                  <Admin />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/users" 
            element={
              <ProtectedRoute allowedRoles={['Presidencia']}>
                <Layout>
                  <Admin />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/departments" 
            element={
              <ProtectedRoute allowedRoles={['Presidencia']}>
                <Layout>
                  <Admin />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/areas" 
            element={
              <ProtectedRoute allowedRoles={['Presidencia']}>
                <Layout>
                  <Admin />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/tags" 
            element={
              <ProtectedRoute allowedRoles={['Presidencia']}>
                <Layout>
                  <Admin />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route path="/" element={<SmartRedirect />} />
          <Route path="*" element={<SmartRedirect />} />
        </Routes>
      </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;